const Urls = {
	Api: {
		info: '/me/api/session',
		ping: '/me/api/session/ping',
		contact_info: '/me/api/session/contact-info'
	}
};

export default Urls;
